import styled, { css } from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

const sharedStyle = css`
  .MuiTableCell-root {
    background-color: ${COLOUR_CONSTANT.theme.background.dark};
    border-bottom: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: 46px;
    border: none;
  }
  &.expanded-row-cell {
    padding: 0;
  }
  .table-title {
    /* width: 100%; */
    align-items: center;
    font-weight: 600;
    text-align: left;
    color: white;
    display: flex;
    justify-content: space-between;
  }
`;
export const TableStyle = styled.div`
  height: 100%;

  .no-data {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dedafb;
    padding: 24px;
  }

  .MuiPaper-root {
    .MuiTable-root {
      width: ${(props) => props.width};
    }

    .MuiTableRow-root {
      height: 50px;

      .MuiTableCell-root {
        margin: 0;
        padding: 0 10px;
        border: 1px solid ${COLOUR_CONSTANT.theme.purple.medium};
        text-align: left;
        &.status-column {
          border-right: 4px solid #dbdfe6;
        }
      }
    }
    .MuiTableHead-root {
      ${sharedStyle}
    }

    .MuiTableRow-footer {
      ${sharedStyle}
    }
  }
`;
